import React, { useEffect, useState } from "react";
import BasicSlider from "./app.basicslider"; // Import your existing BasicSlider component

let bookID: any; // Hardcoded bookID
let tuneNumber: any; // Hardcoded tuneNumber
let kidName: any;
let numPages: any;

function App() {
  const [numPrompts, setNumPrompts] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useState({
    bookID: '',
    tuneNumber: '',
    kidName: '',
    numPages: '',
  });
  const [windowDimensions, setWindowDimensions] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0
  });

  useEffect(() => {
    // Update dimensions on resize
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
      sendDimensionsToParent();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Function to make the POST call to your Lambda endpoint (fire and forget)
const makePostCall = () => {
  console.log("Making POST call to Lambda endpoint...");
  
  fetch('/api/call-full-comic-builder', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      tune_id: tuneNumber,
      char_name: kidName,
      book_id: bookID,
      num_pages_constraint: numPages
    })
  })
  .then(response => {
    if (response.ok) {
      console.log("POST call successful");
    } else {
      console.error("POST call failed:", response.status);
    }
  })
  .catch(error => {
    console.error("Error making POST call:", error);
  });
};

  
// Enhanced function to send dimensions to parent
const sendDimensionsToParent = () => {
  const height = document.body.scrollHeight;
  const width = document.body.clientWidth;
  
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({
      height: height,
      width: width,
      contentReady: true
    }, '*');
    console.log("App sent dimensions to parent:", { height, width });
  }
};

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    bookID = urlParams.get('book_id');
    tuneNumber = urlParams.get('tune_id');
    kidName = urlParams.get('kid_name');
    numPages = parseInt(urlParams.get('num_pages') || '0'); 
    console.log("Setting num pages", numPages);
    console.log("url params", urlParams);
    if (bookID && tuneNumber) {
      setParams({
        bookID,
        tuneNumber,
        kidName,
        numPages
      });
      console.log("bookID", bookID);
      console.log("tuneNumber", tuneNumber);
      console.log("kidName", kidName);
    } else {
      console.log("unable to access params");
    }

    const fetchNumPrompts = async () => {
      try {
        setNumPrompts(numPages);
        makePostCall();
      } catch (error) {
        console.error("Error fetching number of prompts:", error);
      } finally {
        setLoading(false);
        // Notify parent of initial dimensions once everything is loaded
        setTimeout(sendDimensionsToParent, 300);
      }
    };

    fetchNumPrompts();

    // Function to handle messages from child components
    const handleMessage = (event: MessageEvent) => {
      // Make sure the message contains dimension data
      if (event.data) {
        // Forward all data from child sliders to parent window
        if (window.parent && window.parent !== window) {
          window.parent.postMessage(event.data, '*');
          if (event.data.height) {
            console.log("App forwarded height to parent:", event.data.height);
          }
        }
      }
    };

    // Add message listener
    window.addEventListener('message', handleMessage);

    // Initial dimensions notification
    sendDimensionsToParent();
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
    
  }, []);

  // Force a dimensions update when content changes
  useEffect(() => {
    if (!loading && numPrompts !== null) {
      setTimeout(sendDimensionsToParent, 500);
    }
  }, [loading, numPrompts]);

  if (loading) return <p className="text-center text-lg font-semibold">Loading sliders...</p>;

  if (numPrompts === null || numPrompts === 0)
    return <p className="text-center text-lg font-semibold">No prompts found.</p>;

  return (
    <div className="flex justify-center w-full">
      <div className="flex flex-col w-full max-w-full overflow-x-hidden">
        {Array.from({ length: numPrompts }, (_, promptNumber) => (
          <div key={promptNumber} className="!h-[516px]">
            <BasicSlider bookID={bookID} tuneNumber={tuneNumber} promptNumber={promptNumber.toString()} kidName={kidName} />
          </div>
        ))}
      </div> 
    </div> 
  );
}

// Add these to your document head or a styles component
const responsiveStyles = `
  @media (max-width: 768px) {
    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .slick-slide {
      padding: 0 4px;
    }
    .slick-dots {
      bottom: -25px !important;
    }
    body, html {
      overflow-x: hidden;
      width: 100%;
      max-width: 100%;
    }
  }
`;

export default App;